import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setResourcePlanningPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useResourcePlanningSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getResourcePlanningSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.resource_planning_page?.resource_planning_section}`);
      console.log("🚀 ~ getResourcePlanningSectionJson ~ data:", response);
      console.log("🚀 ~ getResourcePlanningSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setResourcePlanningPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Resource Planning section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getResourcePlanningSectionJson();
  }, [getResourcePlanningSectionJson]);

  return {
    data,
    loading,
    error,
    getResourcePlanningSectionJson,
    fetchOnMount,
    refetch: getResourcePlanningSectionJson
  };
};

export default useResourcePlanningSection;
